export default __webpack_public_path__ + "static/media/cloud-pointer.654a8227.svg";